import { isNil } from 'lodash';

const tipPostFix = 'characters remaining';

export default (actualInputLength, limit) => {
  if (limit && isNil(actualInputLength)) {
    return `${limit} ${tipPostFix}`;
  }
  if (!isNil(limit) && !isNil(actualInputLength)) {
    return `${limit - actualInputLength} ${tipPostFix}`;
  }
  return null;
};
